export enum AddImageStates {
  IDLE = 'IDLE',
  PNG_OVER_SIZE = 'PNG_OVER_SIZE',
  PNG_OVER_DIMENSIONS = 'PNG_OVER_DIMENSIONS',
  SELECT_TRANSPARENCY = 'SELECT_TRANSPARENCY',
  PDF_OVER_SIZE = 'PDF_OVER_SIZE',
  PDF_MULTIPLE_PAGES = 'PDF_MULTIPLE_PAGES',
  PDF_OVER_DIMENSIONS = 'PDF_OVER_DIMENSIONS',
  AI_OVER_DIMENSIONS = 'AI_OVER_DIMENSIONS',
  AI_OVER_SIZE = 'AI_OVER_SIZE',
  AI_MULTIPLE_ARTBOARDS = 'AI_MULTIPLE_ARTBOARDS',
  AI_INCOMPATIBLE_VERSION = 'AI_INCOMPATIBLE_VERSION',
  UNSUPPORTED_FILE_FORMAT = 'UNSUPPORTED_FILE_FORMAT',
  UPLOAD_FAILED_BAD_FILE = 'UPLOAD_FAILED_BAD_FILE',
  PROCESSING_FILE = 'PROCESSING_FILE',
  PROCESSING_FAILED_BAD_FILE = 'PROCESSING_FAILED_BAD_FILE',
  PROCESSING_FAILED_UNKNOWN = 'PROCESSING_FAILED_UNKNOWN',
  JPEG_OVER_DIMENSIONS = 'JPEG_OVER_DIMENSIONS',
  PSD_OVER_DIMENSIONS = 'PSD_OVER_DIMENSIONS',
  JPEG_OVER_SIZE = 'JPEG_OVER_SIZE',
  PSD_OVER_SIZE = 'PSD_OVER_SIZE',
  GENERATING_PREVIEW = 'GENERATING_PREVIEW'
}

export enum LoadingMessages {
  DEFAULT = '画像を変換しています',
  PROCESSING_FILE = 'ただいま画像をアップロードしております。しばらくお待ちください。',
  GENERATING_PREVIEW = 'まもなく完了します。商品イメージを見てみましょう。',
}

export type ErrorContent = {
  errorState: string
  message?: string
  pathToGuide?: string
}

type ErrorContents = {
  [key: string]: ErrorContent
}

export const ERROR_CONTENTS: ErrorContents = {
  ue201: {
    errorState: AddImageStates.PROCESSING_FAILED_BAD_FILE
  },
  ue101: {
    errorState: AddImageStates.UPLOAD_FAILED_BAD_FILE
  },
  ue102: {
    errorState: AddImageStates.PDF_MULTIPLE_PAGES,
    message: 'データ内に複数のページが含まれています。',
    pathToGuide: 'https://guide.raksul.com/hc/ja/articles/4407928338191'
  },
  ue103: {
    errorState: AddImageStates.PDF_OVER_DIMENSIONS
  },
  ue104: {
    errorState: AddImageStates.AI_MULTIPLE_ARTBOARDS,
    message: 'データ内に複数のアートボードが含まれています。',
    pathToGuide: 'https://guide.raksul.com/hc/ja/articles/4976367160463#multiple_artboard_ai'
  },
  ue107: {
    errorState: AddImageStates.PNG_OVER_DIMENSIONS
  },
  ue108: {
    errorState: AddImageStates.JPEG_OVER_DIMENSIONS
  },
  ue109: {
    errorState: AddImageStates.PSD_OVER_DIMENSIONS
  },
  ue106: {
    errorState: AddImageStates.AI_OVER_DIMENSIONS
  }
}

export const SELF_ABORT_ERROR = 'The user aborted a request'
